module.exports = __webpack_public_path__ + "static/img/img_5.ecdda09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_5.jpg
// module id = 116
// module chunks = 20